import React, { useState, useContext, useEffect } from 'react';
import { navigate } from 'hookrouter';
import { DataContext } from '../stores/crm-insights-store';
import { GetInitialSettings } from '../components/crm/requests/CommonRequests';
import { CalculateSettings } from '../components/crm/shared/Functions';
import { Header } from '../components/crm/shared/TableCells';
import { CrmRow } from '../components/crm/shared/RowComponents';
import ErrorPage from './error';
import CustomTimeInput from '../components/tables/shared/CustomTimeInput';
import { GetUpdatedSettings, GetWindow } from '../components/crm/requests/CommonRequests';
import { DeepCopy } from '../components/tables/shared/TableEventHelpers';
import ReactLoading from 'react-loading';
import DualDatePickers from '../components/crm/shared/DualDatePickers';
import LoadingSpacer from '../components/crm/shared/LoadingSpacer';

const CrmInsights = () => {
    const [error] = useState(null);
    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1));
    const [endDate, setEndDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 0));
    const {
        store: { apiUrl, layout, viewSettings, requestObject, rows },
        dispatch,
    } = useContext(DataContext);

    useEffect(() => {
        if (typeof startDate === 'string' && typeof endDate === 'string') handeDateStateChange();
    }, [startDate, endDate]);

    const handleDispatchNewData = (res) => {
        if (res.success) {
            let newViewSettings = DeepCopy(viewSettings);
            newViewSettings.maxIndex = res.totalCount;
            newViewSettings = CalculateSettings(newViewSettings, requestObject);

            dispatch({ type: 'UPDATE_DATA', payload: res.data.dataEntities });
            dispatch({ type: 'UPDATE_VIEW_SETTINGS', viewSettings: newViewSettings });
        }
    };

    const handeDateStateChange = () => {
        let newRequestObject = DeepCopy(requestObject);

        newRequestObject.filters['startDate'] = startDate;
        newRequestObject.filters['endDate'] = endDate;
        console.log(newRequestObject);
        dispatch({ type: 'UPDATE_REQUEST_OBJECT', requestObject: newRequestObject });
        GetWindow(apiUrl, newRequestObject, handleDispatchNewData);
    };

    const handeDateChange = ({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
    };

    // todo: uncomment when we have a "/crmUserDetails/" page to navigate to
    // const handleOnClick = (item) => {
    //     navigate('/crmUserDetails/' + item.id);
    // };


    return error && error ? (
        <ErrorPage error={error} />
    ) : (
        <section>
            {viewSettings ? (
                <div
                    className='position-relative d-flex flex-row justify-content-start mb-4 mt-2 mr-2'
                    style={{ zIndex: '999' }}>
                    <DualDatePickers onChange={handeDateChange} customInput={<CustomTimeInput />} startDate={startDate} endDate={endDate} />
                </div>
            ) : (
                <div className='d-flex justify-content-center w-100'>
                    <ReactLoading type={'bars'} color={'#262f3d'} height={60} width={50} />
                </div>
            )}

                <div className='d-flex w-100 crm-container'>
                    <div className='position-relative justify-content-left align-items-left'>
                        <div className='d-flex flex-column'>
                        <Header layout={layout} dataContext={DataContext} />
                        {viewSettings !== null ? (
                            <div className='viewport d-flex flex-column justify-content-center align-items-center w-100'>
                                {!rows.length ? (
                                    <LoadingSpacer isLoading={!rows.length} height={800} />
                                ) : (
                                    rows.map((row) => {
                                        return (
                                            <CrmRow
                                                key={row.id}
                                                layout={layout}
                                                height={viewSettings.itemHeight}
                                                item={row}
                                                //handleOnClick={handleOnClick}
                                            />
                                        );
                                    })
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CrmInsights;
